import { SvgIconComponent } from '@mui/icons-material';
import { AppModules } from '..';

enum GlobalPaths {
  LOGIN = '/',
  RESET_PASSWORD = '/reset-password',
  HOME = '/home',
  PROFILE = '/profile',
  SIGN_UP = '/signup',
  NOT_INVITED = '/not-invited',
  NOT_ALLOWED = '/not-allowed',
  ONBOARDING = '/onboarding',
  NOT_FOUND = '/not-found',
}

enum PeopleXPaths {
  USERS = '/peoplex/users',
  USER_CHECKINS = '/peoplex/users/:userId/checkins',
  USER_CHECKIN_DETAILS = '/peoplex/users/:userId/checkins/:checkinId',
  ROTATING_QUESTIONS = '/peoplex/rotating-questions',
  MANAGE_ROTATING_QUESTION = '/peoplex/rotating-questions/manage',
  TRENDS_REPORT = '/peoplex/reports/trends',
  TRENDS_REPORT_DETAIL = '/peoplex/reports/trends/:questionId',
  TEAMS = '/peoplex/teams',
  CHECKINS_REPORT = '/peoplex/reports/checkins',
  CHECKINS_UNREVIEWED = '/peoplex/checkins/unreviewed',
  PTO_REQUESTS = '/peoplex/pto-requests',
  STAFF = '/peoplex/staff',
  STAFF_MEMBER_INFO = '/peoplex/staff/:id',
  STAFF_MEMBER_JOB = '/peoplex/staff/:id/job',
  STAFF_MEMBER_BACKGROUND = '/peoplex/staff/:id/background',
  STAFF_MEMBER_REVIEWS = '/peoplex/staff/:id/reviews',
  STAFF_MEMBER_TIME_OFF = '/peoplex/staff/:id/time-off',
  STAFF_MEMBER_NOTES = '/peoplex/staff/:id/notes',
  STAFF_MEMBER_ATTACHMENTS = '/peoplex/staff/:id/attachments',
}

enum UserPaths {
  MY_CHECKINS = '/peoplex/my-checkins',
  MY_CURRENT_CHECKIN = '/peoplex/my-checkins/current',
  MY_CHECKIN_DETAILS = '/peoplex/my-checkins/:checkinId',
}

enum TalentXPaths {
  CANDIDATE_PRE_SCREENING_INTERVIEW = '/interview/pre-screening/:interviewId/:candidateId',
  CANDIDATE_TECHNICAL_VALIDATION_INTERVIEW = '/interview/technical-challenge/:interviewId/:candidateId',
  CANDIDATES = '/talentx/candidates',
  CANDIDATES_BOARD = '/talentx/candidates/board',
  CANDIDATE_DETAILS = '/talentx/candidates/:id',
  CANDIDATE_NOTES = '/talentx/candidates/:id/notes',
  CANDIDATE_INTERVIEWS = '/talentx/candidates/:id/interviews',
  CANDIDATE_JOBS = '/talentx/candidates/:id/jobs',

  CHALLENGES = '/talentx/challenges',
  CHALLENGES_REVIEWERS = '/talentx/reviewers',

  TALENT_POOL = '/talentx/talent-pool',
  TALENT_POOL_BOARD = '/talentx/talent-pool/board',
  TALENT_POOL_DETAILS = '/talentx/talent-pool/:id',
  TALENT_POOL_NOTES = '/talentx/talent-pool/:id/notes',
  TALENT_POOL_INTERVIEWS = '/talentx/talent-pool/:id/interviews',
  TALENT_POOL_JOBS = '/talentx/talent-pool/:id/jobs',

  REPORTS = '/talentx/reports',
  REPORTS_TRENDS = '/talentx/reports/trends',

  JOBS = '/talentx/jobs',
  JOB_DETAILS = '/talentx/jobs/:jobId',
  JOB_CANDIDATES = '/talentx/jobs/:jobId/candidates',
  JOB_NOTES = '/talentx/jobs/:jobId/notes',
}

enum TrioAcademyPaths {
  SEMINARS = '/academy/seminars',
  SEMINARS_DETAILS = '/academy/seminars/:id',
}

enum HomePaths {
  HOME_PERSONAL_INFO = '/home/personal',
  HOME_PTO_REQUESTS = '/home/pto-requests',
  HOME_ATTACHMENTS = '/home/attachments',
}

enum SEOxPaths {
  SEOX_PROJECTS = '/seox',
  SEOX_PROJECT_OVERVIEW = '/seox/projects/:projectId',
  SEOX_PROJECT_AUDITS = '/seox/projects/:projectId/audits',
  SEOX_PROJECT_AUDIT = '/seox/projects/:projectId/audits/:auditId',
  SEOX_PROJECT_KEYWORDS = '/seox/projects/:projectId/keywords',
  SEOX_PROJECT_KEYWORD = '/seox/projects/:projectId/keywords/:keywordId',
  SEOX_PROJECT_CONTENT = '/seox/projects/:projectId/content',
  SEOX_PROJECT_CONTENT_DETAIL = '/seox/projects/:projectId/content/:analysisId',
  SEOX_PROJECT_REPORTS = '/seox/projects/:projectId/reports',
  SEOX_PROJECT_SETTINGS = '/seox/projects/:projectId/settings',
}

enum FinanceXPaths {
  FINANCEX_DASHBOARD = '/financex',
  FINANCEX_VENDORS = '/financex/vendors',
  FINANCEX_VENDOR_DETAIL = '/financex/vendors/:id',
  FINANCEX_SUBSCRIPTIONS = '/financex/subscriptions',
  FINANCEX_SUBSCRIPTION_DETAIL = '/financex/subscriptions/:id',
  FINANCEX_TRANSACTIONS = '/financex/transactions',
  FINANCEX_IMPORT = '/financex/import',
  FINANCEX_RULES = '/financex/rules',
  FINANCEX_CLIENTS = '/financex/clients',
  FINANCEX_REVIEW = '/financex/review',
  FINANCEX_BANK_ACCOUNTS = '/financex/bank-accounts',
  FINANCEX_INVOICES = '/financex/invoices',
  FINANCEX_INVOICE_DETAIL = '/financex/invoices/:invoiceId',
  FINANCEX_ONBOARDING = '/financex/onboarding',
  FINANCEX_PNL = '/financex/pnl',
  FINANCEX_CONTRACTORS = '/financex/contractors',
  FINANCEX_PAYROLL = '/financex/payroll',
  FINANCEX_PAYROLL_REPORT = '/financex/payroll/:reportId',
}

enum CEOxPaths {
  CEOX_DASHBOARD = '/ceox',
  CEOX_STACK_SETUP = '/ceox/setup',
  CEOX_PIPELINE = '/ceox/pipeline',
  CEOX_COLD_EMAIL = '/ceox/cold-email',
  CEOX_SEO = '/ceox/seo',
  CEOX_GOOGLE_ADS = '/ceox/google-ads',
  CEOX_SETTINGS = '/ceox/settings',
}

enum SettingsPaths {
  SETTINGS_USERS = '/settings/users',
  SETTINGS_PERMISSIONS = '/settings/permissions',
  SETTINGS_INTEGRATIONS = '/settings/integrations',
}

/** @deprecated Old paths kept for redirect mapping */
export enum LegacyPaths {
  // Old /hiring/* paths
  HIRING_CANDIDATES = '/hiring/candidates',
  HIRING_CANDIDATES_BOARD = '/hiring/candidates/board',
  HIRING_CANDIDATE_DETAILS = '/hiring/candidates/:id',
  HIRING_CANDIDATE_NOTES = '/hiring/candidates/:id/notes',
  HIRING_CANDIDATE_INTERVIEWS = '/hiring/candidates/:id/interviews',
  HIRING_CANDIDATE_JOBS = '/hiring/candidates/:id/jobs',
  HIRING_CHALLENGES = '/hiring/challenges',
  HIRING_CHALLENGES_REVIEWERS = '/hiring/reviewers',
  HIRING_TALENT_POOL = '/hiring/talent-pool',
  HIRING_TALENT_POOL_BOARD = '/hiring/talent-pool/board',
  HIRING_TALENT_POOL_DETAILS = '/hiring/talent-pool/:id',
  HIRING_TALENT_POOL_NOTES = '/hiring/talent-pool/:id/notes',
  HIRING_TALENT_POOL_INTERVIEWS = '/hiring/talent-pool/:id/interviews',
  HIRING_TALENT_POOL_JOBS = '/hiring/talent-pool/:id/jobs',
  HIRING_REPORTS = '/hiring/reports',
  HIRING_REPORTS_TRENDS = '/hiring/reports/trends',
  HIRING_JOBS = '/hiring/jobs',
  HIRING_JOB_DETAILS = '/hiring/jobs/:jobId',
  HIRING_JOB_CANDIDATES = '/hiring/jobs/:jobId/candidates',
  HIRING_JOB_NOTES = '/hiring/jobs/:jobId/notes',
  // Old /people/* paths
  PEOPLE_USERS = '/people/users',
  PEOPLE_USER_CHECKINS = '/people/users/:userId/checkins',
  PEOPLE_USER_CHECKIN_DETAILS = '/people/users/:userId/checkins/:checkinId',
  PEOPLE_ROTATING_QUESTIONS = '/people/rotating-questions',
  PEOPLE_MANAGE_ROTATING_QUESTION = '/people/rotating-questions/manage',
  PEOPLE_TRENDS_REPORT = '/people/reports/trends',
  PEOPLE_TRENDS_REPORT_DETAIL = '/people/reports/trends/:questionId',
  PEOPLE_TEAMS = '/people/teams',
  PEOPLE_CHECKINS_REPORT = '/people/reports/checkins',
  PEOPLE_CHECKINS_UNREVIEWED = '/people/checkins/unreviewed',
  PEOPLE_PTO_REQUESTS = '/people/pto-requests',
  PEOPLE_STAFF = '/people/staff',
  PEOPLE_STAFF_MEMBER_INFO = '/people/staff/:id',
  PEOPLE_MY_CHECKINS = '/people/my-checkins',
  PEOPLE_MY_CHECKIN_DETAILS = '/people/my-checkins/:checkinId',
}

export const Paths = {
  ...GlobalPaths,
  ...PeopleXPaths,
  ...UserPaths,
  ...TalentXPaths,
  ...TrioAcademyPaths,
  ...SEOxPaths,
  ...FinanceXPaths,
  ...HomePaths,
  ...CEOxPaths,
  ...SettingsPaths,
};

export type SidebarOptionType = {
  path: string;
  label: string;
  icon: SvgIconComponent;
};

export type HeaderMenuOptionType = {
  icon: SvgIconComponent;
  label: string;
  sidebarMenus: SidebarOptionType[];
  module: AppModules;
  path: string;
  adminOnly?: boolean;
};

export type ServiceDefinition = {
  id: AppModules;
  name: string;
  description: string;
  icon: SvgIconComponent;
  color: string;
  basePath: string;
  landingPath?: string;
  sidebarMenus: SidebarOptionType[];
  requiredRoles?: string[];
  adminOnly?: boolean;
};
